
import { useNavigate } from "react-router-dom";
import { TableBody, TableCell, TableHead, TableRow,  Typography, Stack, Pagination } from "@mui/material";
import { MensajeAlertaDanger, TooltipAndIcon } from "../../components";
import { LayoutTabla } from "../../layouts";
import { eliminarCotizacion, generarOpDesdeVenta } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";

import Swal from "sweetalert2";
import dayjs from "dayjs";
const paginado = Number(process.env.REACT_APP_PAGINADO);




export const TablaListadoVentasGuardadas = ({ data, chagePage=null, page=0 }) => {


    const queryClient = useQueryClient();
    const navigate = useNavigate();


    const handleEnviarAlCarrito = async (cotizacion) => {
        const { value } = await Swal.fire({
            title: 'Importante',
            text: `El carrito se vaciará para cargar los nuevos productos.`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });
        if( !value ) return;

        const resp = await generarOpDesdeVenta({id: cotizacion.id});
        if(resp){
            queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });
            navigate(`/super/comprar-ahora`);
        }
    }




    const hendleDelete = async(id) => {
        const { value } = await Swal.fire({
            title: 'Eliminar Venta Guardada',
            text: `¿Esta seguro de eliminar esta venta guardada?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Si' 
        });
        if( !value ) return;

        const resp = await eliminarCotizacion(id);
        if(resp){
            queryClient.invalidateQueries({ queryKey: ['todas-ventas-save'] });
        }
    }




    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla mt={3}
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(50 / +paginado)} disabled={Math.ceil(50 / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'10%'}}>Cotizacion</TableCell>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'20%'}}>Tipo</TableCell>
                        <TableCell sx={{width:'15%'}}>Rol</TableCell>
                        <TableCell sx={{width:'15%'}}>Estado</TableCell>
                        <TableCell sx={{width:'10%'}}># Items</TableCell>
                        <TableCell sx={{width:'15%'}}>Acciones</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {data.map((co) => (
                    <TableRow  key={ co.id }>  
                        <TableCell >{ co.cotizacion }</TableCell>
                        <TableCell><Typography variant="span">{ dayjs(co.fechaFactura).format('ll') }</Typography></TableCell>
                        <TableCell>{co.tipo}</TableCell>
                        <TableCell><Typography variant="span" >{ co.tipoRol }</Typography></TableCell>
                        <TableCell>
                            <Typography variant="span" sx={{fontWeight:'bold', color:co.estado === 'ACTIVA' ? 'white' : 'error' }}>
                                { co.estado }
                            </Typography>
                        </TableCell>
                        <TableCell>{co.items.length}</TableCell>

                        <TableCell sx={{display:'flex', justifyContent:'center'}}>
                            <Stack spacing={1} direction="row">
                                <TooltipAndIcon
                                    titulo="Comprar Ahora"
                                    icono="comprar"
                                    color="white"
                                    onClick={ () => handleEnviarAlCarrito(co) }
                                /> 

                                <TooltipAndIcon
                                    titulo="Eliminar cotización"
                                    icono="eliminar"
                                    color="white"
                                    onClick={ () => hendleDelete(co.id) }
                                /> 
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </LayoutTabla>

        :   <MensajeAlertaDanger titulo='No hay ventas guardadas disponibles' />
        }
        </>
    )
}
